import { useEffect, useState } from "react"

import styles from "./dot-row.module.css"
import { Dot } from "./dot/dot"

// Dot row. Each row has 51 dots on mobile, 31 on desktop,
// 10 are hidden on each side for larger screens.
// This allows for more content to be seen while still
// experiencing the entire dot field animation on mobile.
const TOTALDOTS = 51
const COLUMNCOUNT = (TOTALDOTS - 1) / 2

export function DotRow({ rowIndex }: { rowIndex: number }) {
  let [dots, setDots] = useState<React.ReactNode>(null)

  useEffect(() => {
    let tempDots = []
    for (let colIndex = -COLUMNCOUNT; colIndex <= COLUMNCOUNT; colIndex++) {
      let randomInt1to500 = Math.floor(Math.random() * (500 - 1 + 1) + 1)
      tempDots.push(
        <Dot key={colIndex} colIndex={colIndex} randomIndex={randomInt1to500} rowIndex={rowIndex} />
      )
    }
    setDots(tempDots)
  }, [rowIndex])

  return <div className={styles["container"]}>{dots}</div>
}
